import {CHANGE_IMAGE, FETCH_WT_DATA_SUCCESS, FETCH_WT_DATA_ERROR, CHANGE_DATA} from "../actions/types";
import initialState from './initialState';
import {calculateLengthWidth, additionalCalculation} from '../utils/helpers';
import {Maybe} from '../utils/logging';

export default (prevState = initialState.WT, action) => {
    switch (action.type) {

        case FETCH_WT_DATA_SUCCESS:
            return {...prevState, ...action.payload};

        case FETCH_WT_DATA_ERROR:
            return prevState;

        case CHANGE_DATA:
            const {name, value, articleName, articleID} = action.payload;
            if (articleName === 'WT') {
                let newState = {...prevState};
                // update value of input field
                newState[name].CurrentValue = value;
                if (!newState.articleID) {
                    newState.articleID = articleID;
                }
                // calculate lenght, depth, position on the step 1 if VAR_ABM = 0
                if (newState['VAR_ABM'].CurrentValue === '0') {
                    switch (name) {

                        case 'BREITE':
                            newState = calculateLengthWidth('BREITE', newState, 'wt', ['SO45', 'SO81']);
                        break;
                        case 'TIEFE':
                            newState = calculateLengthWidth('TIEFE', newState, 'wt', ['SO23', 'SO67'])
                        break;
                        case 'SO23':
                            newState = additionalCalculation('SO23', newState, 'wt', ['TIEFE'], 'SO67')
                        break;
                        case 'SO67':
                            newState = additionalCalculation('SO67', newState, 'wt', ['TIEFE'], 'SO23')
                        break;
                        case 'SO45':
                            newState = additionalCalculation('SO45', newState, 'wt', ['BREITE'], 'SO81')
                        break;
                        case 'SO81':
                            newState = additionalCalculation('SO81', newState, 'wt', ['BREITE'], 'SO45')
                        break;

                    }
                }

                // kill activator dependent fields
                console.log("Activator >", name);
                switch (name) {
                    case "MISSING_WT_ALAZ_checkbox":
                        if (newState.MISSING_WT_ALAZ_checkbox.CurrentValue === '0') {
                            newState.WT_ALAZ.CurrentValue = '0';
                            newState.WT_ALP1.CurrentValue = '-';
                            newState.WT_ALP2.CurrentValue = '-';
                        }
                        break;
                    case "MISSING_SSPV_checkbox":
                        if (newState.MISSING_SSPV_checkbox.CurrentValue === '0') {
                            newState.SSP.CurrentValue = '00';
                        }
                        break;
                    case "MISSING_WT_ALS_checkbox":
                        if (newState.MISSING_WT_ALS_checkbox.CurrentValue === '0') {
                            newState.WT_ALS.CurrentValue = '00';
                        }
                        break;
                    case "MISSING_KTSV_checkbox":
                        if (newState.MISSING_KTSV_checkbox.CurrentValue === '0') {
                            newState.KTS.CurrentValue = '0';
                        }
                        break;
                }

                return newState;

            } else {
                return prevState;
            }

        case CHANGE_IMAGE:
            if (action.name === 'wt') {
                const state = {...prevState};
                state["image"] = action.payload;
                return state;
            }
            return prevState;

        default:
            return prevState;

    }
}




// WEBPACK FOOTER //
// ./src/reducers/wtReducer.js